import backendAPIClient from '../apiClient';

export default function getFrontEggUser() {
    return backendAPIClient.get(`users/frontegg/me`).then((result) => result.data);
}
